module.exports = __webpack_public_path__ + "static/media/logo-dashboard.078d9ea6.svg";